import ElOptionGroup from './OptionGroup'

/* istanbul ignore next */
ElOptionGroup.install = function (app) {
  app.component(ElOptionGroup.name, ElOptionGroup)
}

export default ElOptionGroup
